import React from 'react';
import { Button } from 'antd';
import 'antd/dist/antd.css';
import { Link, RouteComponentProps, useRouteMatch } from 'react-router-dom';
import { FaUserEdit } from 'react-icons/fa';
// eslint-disable-next-line @typescript-eslint/no-empty-interface
// export interface IOptionsProps {}

export const ClasseOptions = (props: RouteComponentProps<{ id: string; ecoleid: string }>) => {
  const { url } = useRouteMatch();
  const { match } = props;
  const id = props.match.params.id;
  const ecoleId = props.match.params.ecoleid;
  return (
    <div>
      <Button type="primary">
        <Link to={`/classe/${ecoleId}/${id}/edit`} id="jh-create-entity" data-cy="entityCreateButton">
          <FaUserEdit title="editer" />
          &nbsp; Modifier
        </Link>
      </Button>
    </div>
  );
};

export default ClasseOptions;
